import { type CardRefType } from '@/defs/card'
import { type IconType } from '@/defs/icon'
import { type Dict, type LabelType } from '@/defs/misc'
import { type ColorIdType } from '@/defs/mtg'

export type ComboVoteType = {
  bracket?: string
  controversial?: boolean
  earlyScore?: number
  prereqScore?: number
  resultScore?: number
  voteCount?: number
}

export type ComboBaseType = {
  cards: CardRefType[]
  id: string
  numDecks: number
  potentialDecks: number
  rank: number
  results: string[]
  vote?: ComboVoteType
}

export type ComboBracketType = {
  message: string
  status: 'valid' | 'invalid' | 'warning'
}

type ComboWithBracketInfoType = {
  bracketInfo: {
    low: ComboBracketType
    mid: ComboBracketType
  }
}

export type ComboPreviewType = ComboBaseType &
  ComboWithBracketInfoType & {
    colorId: ColorIdType
    nonCardPrerequisiteCount: number
  }

export type ComboPrerequisiteType = {
  description: string
  zones: ComboZoneType[]
}

export type ComboFeaturedType = ComboBaseType &
  ComboWithBracketInfoType & {
    prerequisites: ComboPrerequisiteType[]
    rankDistribution: Dict<number>
    steps: string[]
    totalComboCount: number
    weightedRank: number
  }

export const NONPERMANENT_TYPES = ['instant', 'sorcery']

export const COMBO_ZONES = ['B', 'C', 'E', 'G', 'H', 'L', 'M'] as const
export type ComboZoneType = (typeof COMBO_ZONES)[number]
export const isComboZoneType = (key?: string): key is ComboZoneType => COMBO_ZONES.includes(key as ComboZoneType)
export const COMBO_ZONE_LABELS: LabelType<ComboZoneType, { icon: IconType }> = {
  B: { icon: 'chessBoard', label: 'on the battlefield' },
  C: { icon: 'chessRook', label: 'in the command zone' },
  E: { icon: 'ban', label: 'in exile' },
  G: { icon: 'skullCrossbones', label: 'in your graveyard' },
  H: { icon: 'hand', label: 'in hand' },
  L: { icon: 'book', label: 'in your library' },
  M: { icon: 'chartSimple', label: 'needs mana' },
}
